<template>
  <div>
    <v-card
      class="mx-auto"
      color="transparent"
      elevation="0"
    >
      <v-card
        :style="`z-index: 1; position: sticky; top: ${focusModeToolbarTop()};`"
        color="rgba(255, 255, 255, 0.8)"
      >
        <v-alert
          v-if="!$store.getters.isCentralizedWorkspace && hasUuid && offerData.status === 'published'"
          v-show="!showPreview"
          align="right"
          class="mb-0 px-12"
          style="background: #b3e5fc91;"
        >
          <!-- <v-btn v-if="hasDifuseLink" color="success" :disabled="!hasDifuseLink" @click="handleBroadBeanApplication">Diffusion et gestion de l'annonce</v-btn> -->

          <v-btn
            :disabled="!canPerformAction('DIFFUSE_OFFER') || !user.broadBeanUsername"
            color="success"
            @click="handleBroadBeanApplication"
          >
            Générer le lien de diffusion
          </v-btn>
        </v-alert>
        <EditToolbar :loading="loading.skeleton">
          <template #title-section>
            <v-btn small icon fab class="px-0" text :to="{ name: 'offers', params: { contentTypeLabel: 'offres' }, query: {} }">
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>

            <v-toolbar-title v-if="!isViewMode">Modifier l'offre</v-toolbar-title>

            <v-toolbar-title v-else>Voir l'offre</v-toolbar-title>

            <v-btn
              v-if="!$store.getters.isCentralizedWorkspace && hasUuid"
              icon
              fab
              :disabled="!canPerformAction('VIEW_OFFER') || loading.skeleton"
              @click="openFile"
            >
              <v-icon>mdi-download</v-icon>
            </v-btn>
          </template>

          <template #desktop-actions>
            <v-btn
              v-if="hasUuid"
              icon
              fab
              :disabled="!canPerformAction('VIEW_OFFER') || loading.skeleton"
              @click="setShowPreview"
            >
              <v-icon v-if="!showPreview">mdi-eye</v-icon>
              <v-icon v-else>mdi-eye-off</v-icon>
            </v-btn>
            <v-btn
              v-if="!isViewMode"
              color="primary"
              :disabled="!canPerformAction('EDIT_OFFER') || !canSave || loading.skeleton"
              @click="saveOffer(offerData.status || null)"
            >
              Enregistrer
            </v-btn>
            <v-btn
              v-if="!$store.getters.isCentralizedWorkspace && hasUuid"
              color="lightBlue"
              :disabled="!canPerformAction('EDIT_OFFER') || loading.skeleton"
              @click="openDialogByType('duplicateOffer')"
            >
              Dupliquer l'offre
            </v-btn>
            <v-btn
              v-if="!isViewMode && hasUuid && canGenerateOfferLLm"
              color="lightGray"
              :disabled="!canPerformAction('EDIT_OFFER') || loading.skeleton"
              @click="openDialogByType('generateOfferLLmData')"
            >
              Générer llm
            </v-btn>
            <v-btn
              v-if="!$store.getters.isCentralizedWorkspace && !isViewMode && !hasUuid"
              color="success"
              :disabled="!canPerformAction('EDIT_OFFER') || !canPublish || loading.skeleton"
              @click="openDialogByType('offer', { status: 'published' })"
            >
              Enregistrer et publier l’offre
            </v-btn>
            <v-btn
              v-if="$store.getters.isCentralizedWorkspace && hasUuid"
              color="lightBlue"
              :disabled="!canPerformAction('EDIT_OFFER') || !dispatchEntities.length || loading.skeleton"
              @click="dispatchOffer()"
            >
              Dispatcher l’offre
            </v-btn>

            <v-btn
              v-if="$store.getters.isCentralizedWorkspace && hasUuid"
              color="success"
              :disabled="!canPerformAction('EDIT_OFFER') || !canPublish || !dispatchEntities.length || loading.skeleton"
              @click="dispatchOffer('published')"
            >
              Dispatcher l’offre et publier
            </v-btn>
            <v-btn
              v-if="!$store.getters.isCentralizedWorkspace && !isViewMode && hasUuid"
              color="success"
              :disabled="!canPerformAction('EDIT_OFFER') || !canPublish || loading.skeleton"
              @click="openDialogByType('offer', { status: 'published' })"
            >
              Publier l’offre
            </v-btn>
            <v-btn
              v-if="!isViewMode && hasUuid"
              :disabled="!canReset || loading.skeleton"
              @click="resetModifications"
            >
              Annuler les modifications
            </v-btn>
          </template>
          <template #mobile-actions>
            <v-list-item v-if="hasUuid" :disabled="!canPerformAction('VIEW_OFFER')" @click="setShowPreview">
              <v-list-item-icon>
                <v-icon v-if="!showPreview">mdi-eye</v-icon>
                <v-icon v-else>mdi-eye-off</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Aperçu</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="!isViewMode" :disabled="!canPerformAction('EDIT_OFFER') || !canSave" @click="saveOffer(offerData.status || null)">
              <v-list-item-icon>
                <v-icon>mdi-content-save</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Enregistrer</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="!$store.getters.isCentralizedWorkspace && !isViewMode && !hasUuid" :disabled="!canPerformAction('EDIT_OFFER') || !canPublish" @click="openDialogByType('offer', { status: 'published' })">
              <v-list-item-icon>
                <v-icon>mdi-content-save-check</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Enregistrer et publier l’offre</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="!$store.getters.isCentralizedWorkspace && !isViewMode && hasUuid" :disabled="!canPerformAction('EDIT_OFFER') || !canPublish" @click="openDialogByType('offer', { status: 'published' })">
              <v-list-item-icon>
                <v-icon>mdi-content-save-check</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Publier l’offre</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="!$store.getters.isCentralizedWorkspace && hasUuid" :disabled="!canPerformAction('EDIT_OFFER') || loading.skeleton" @click="openDialogByType('duplicateOffer')">
              <v-list-item-icon>
                <v-icon>mdi-content-copy</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Dupliquer l'offre</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="$store.getters.isCentralizedWorkspace && hasUuid" :disabled="!canPerformAction('EDIT_OFFER') || !dispatchEntities.length" @click="dispatchOffer()">
              <v-list-item-icon>
                <v-icon>mdi-content-save-check</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Dispatcher l’offre</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="$store.getters.isCentralizedWorkspace && hasUuid" :disabled="!canPerformAction('EDIT_OFFER') || !canPublish || !dispatchEntities.length" @click="dispatchOffer('published')">
              <v-list-item-icon>
                <v-icon>mdi-content-save-check</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Dispatcher l’offre et publier</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="!isViewMode && hasUuid && canGenerateOfferLLm" :disabled="!canPerformAction('EDIT_OFFER') || loading.skeleton" @click="openDialogByType('generateOfferLLmData')">
              <v-list-item-icon>
                <v-icon>mdi-newspaper-variant</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Générer llm</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="!isViewMode && hasUuid" :disabled="!canReset" @click="resetModifications">
              <v-list-item-icon>
                <v-icon>mdi-refresh</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Annuler les modifications</v-list-item-title>
            </v-list-item>
          </template>

          <template #after-actions>
            <ActionsContent
              v-if="isViewMode"
              :actions="[activeBoardConfiguration.actions.edit]"
              :item="offerData"
              :content-type-label="'offres'"
              class="ml-2"
            />
            <v-btn
              v-if="!loading.skeleton && Object.keys(mandatoryFields).length && $vuetify.breakpoint.smAndDown"
              color="primary"
              absolute
              right
              fab
              small
              style="top: 62px; z-index: 1000;"
              @click="drawer = true"
            >
              <v-icon>mdi-alert-circle</v-icon>
            </v-btn>
          </template>
        </EditToolbar>

        <v-toolbar
          v-if="!loading.skeleton && !$store.getters.isCentralizedWorkspace && !isViewMode"
          flat
          dense
          color="rgba(255, 255, 255, 0.8)"
          class="px-4"
          height="48"
        >
          <v-spacer />
          <v-switch
            v-if="!offerData.confidential"
            :value="offerData.confidential"
            class="mt-0 pt-0"
            label="Rendre cette offre confidentielle"
            hide-details
            inset
            @change="handleConfidentialChange"
          />
          <v-btn
            v-else
            text
            color="primary"
            class="ml-4"
            @click="confidentialDialog = true"
          >
            Gérer les accès
            <v-icon right>
              mdi-lock
            </v-icon>
          </v-btn>
        </v-toolbar>

        <ConfidentialAccessPopup
          v-if="offerData.confidential"
          v-model="offerData.allowedCollaborators"
          :show-dialog.sync="confidentialDialog"
        />

        <v-progress-linear
          v-if="loading.form"
          indeterminate
          color="primary"
        />
      </v-card>
      <v-row
        v-if="!showPreview"
        class="my-8 px-4 px-md-8 flex-column-reverse flex-md-row"
        :class="{ 'mt-12' : focusMode }"
        no-gutters
      >
        <v-col
          cols="12"
          :md="Object.keys(mandatoryFields).length ? 5 : 6"
          class="pa-0"
        >
          <v-card-text class="pa-0">
            <v-form
              v-model="isFormOneValid"
              class="d-flex flex-column"
              style="gap: 26px;"
            >
              <fieldset
                v-for="(panel, panelIndex) in rawContentType.panelOrder"
                :key="panelIndex"
                class="d-flex flex-column py-4 px-4"
                style="gap: 16px; border-radius: 10px; border: 0; background: white;"
              >
                <legend
                  class="
                    py-2 px-4
                    overline text-h6 rounded-lg
                  "
                  style="background-color: #e0e0e0;"
                >
                  {{ panel }}
                </legend>

                <template
                  v-for="(input, inputIndex) in getPanel(panel)"
                >
                  <div
                    v-if="showField(input.name)"
                    :ref="input.name"
                    :key="inputIndex"
                    class="px-0"
                    style="background: white; border-radius: 10px;"
                  >
                    <v-skeleton-loader
                      v-if="loading.skeleton"
                      type="list-item"
                    />
                    <template
                      v-else
                    >
                      <template
                        v-if="!['convention', 'position', 'selectedApplicationMethod'].includes(input.name)"
                      >
                        <component
                          :is="input.component ? input.component : 'GenericField'"
                          v-model="offerData[input.name]"
                          :name="input.name"
                          :data="offerData"
                          :input="input"
                          :field="computedFields[input.name]"
                          :items="getFieldItems(computedFields[input.name])"
                          :options="references"
                          :classes="getInputClasses(computedFields[input.name])"
                          :clearable="!isViewMode"
                        />
                      </template>

                      <template
                        v-else-if="input.name === 'position'"
                      >
                        <PositionInput
                          v-if="$store.getters.isCentralizedWorkspace"
                          v-model="offerData.position"
                          :name="input.name"
                          :data="offerData"
                          :input="input"
                          :field="{ ...input, readonly: isViewMode || !$store.getters.isCentralizedWorkspace, disabled: isViewMode || !$store.getters.isCentralizedWorkspace }"
                          :classes="getInputClasses(computedFields.position)"
                          :clearable="!isViewMode"
                          @item="handleItem"
                          @init-position="handlePositionInit"
                        />
                        <GenericField
                          v-else
                          :value="offerPosition?.name"
                          :name="input.name"
                          :data="offerData"
                          :input="input"
                          :field="{ ...input, readonly: isViewMode || !$store.getters.isCentralizedWorkspace, disabled: isViewMode || !$store.getters.isCentralizedWorkspace }"
                          :classes="getInputClasses(computedFields.position)"
                          :clearable="!isViewMode"
                        />
                      </template>

                      <template
                        v-else-if="input.name === 'convention'"
                      >
                        <GenericField
                          v-if="$store.getters.isCentralizedWorkspace"
                          v-model="offerData.convention"
                          :name="input.name"
                          :data="offerData"
                          :items="positionConventions"
                          :input="input"
                          :field="{ ...input, readonly: isViewMode || !$store.getters.isCentralizedWorkspace, disabled: isViewMode || !$store.getters.isCentralizedWorkspace }"
                          :classes="getInputClasses(computedFields.convention)"
                          :clearable="!isViewMode"
                        />
                        <GenericField
                          v-else
                          :value="offerConvention?.name"
                          :name="input.name"
                          :data="offerData"
                          :input="input"
                          :field="{ ...input, readonly: isViewMode || !$store.getters.isCentralizedWorkspace, disabled: isViewMode || !$store.getters.isCentralizedWorkspace }"
                          :classes="getInputClasses(computedFields.convention)"
                          :clearable="!isViewMode"
                        />
                      </template>

                      <template
                        v-else-if="input.name === 'selectedApplicationMethod'"
                      >
                        <EntityInput
                          :key="isViewMode"
                          :field="computedFields[input.name]"
                          :selected-entity-uuid="offerData.selectedApplicationMethod"
                          :classes="getInputClasses(computedFields.selectedApplicationMethod)"
                          :read-only="isViewMode"
                          :items="entityManager.applicationMethods || []"
                          @entity-response="setEntityItems('applicationMethods', $event)"
                          @init-entity="initEntity('applicationMethods', $event)"
                          @selected-entity="setSelectedEntity('applicationMethods', $event)"
                        />
                      </template>
                    </template>
                  </div>
                </template>
              </fieldset>
            </v-form>
          </v-card-text>
        </v-col>
        <v-col
          cols="12"
          :md="Object.keys(mandatoryFields).length ? 5 : 6"
          class="pa-0 pl-md-4"
        >
          <v-card-text class="pa-0 d-flex flex-column" style="gap: 26px;">
            <v-form
              v-if="$store.getters.isCentralizedWorkspace"
              class="d-flex flex-column"
              style="gap: 26px;"
            >
              <fieldset
                class="d-flex flex-column py-4 px-4"
                style="gap: 16px; border-radius: 10px; border: 0; background: white;"
              >
                <legend
                  class="
                    py-2 px-4
                    overline text-h6 rounded-lg
                  "
                  style="background-color: #e0e0e0;"
                >
                  Établissements Cibles
                </legend>

                <DispatchOffers
                  v-model="dispatchEntities"
                  :dispatched-offers="offerData.dispatchedOffers"
                  :is-parent-loading="loading.skeleton"
                />
              </fieldset>
            </v-form>

            <v-form
              v-model="isFormTwoValid"
              class="d-flex flex-column"
              style="gap: 26px;"
            >
              <fieldset
                class="d-flex flex-column py-4 px-4"
                style="gap: 16px; border-radius: 10px; border: 0; background: white;"
              >
                <legend
                  class="
                    py-2 px-4
                    overline text-h6 rounded-lg
                  "
                  style="background-color: #e0e0e0;"
                >
                  Période et contrat de l'offre
                </legend>

                <v-row
                  class="px-0"
                  style="background: white; border-radius: 10px;"
                >
                  <template
                    v-for="(input, inputIndex) in getPanel('Période et contrat de l\'offre')"
                  >
                    <v-col
                      v-if="showField(input.name)"
                      :ref="input.name"
                      :key="inputIndex"
                      cols="12"
                      :md="handleCol(input)"
                      class="py-0"
                    >
                      <v-skeleton-loader
                        v-if="loading.skeleton"
                        type="list-item"
                      />
                      <template
                        v-else
                      >
                        <component
                          :is="input.component ? input.component : 'GenericField'"
                          v-if="input.viewType !== 'Switch'"
                          v-model="offerData[input.name]"
                          :name="input.name"
                          :data="offerData"
                          :input="input"
                          :field="computedFields[input.name]"
                          :items="getFieldItems(computedFields[input.name])"
                          :options="references"
                          :classes="getInputClasses(computedFields[input.name])"
                          :clearable="!isViewMode"
                          :rules="getRules(input.name)"
                        />
                        <v-switch
                          v-else
                          v-model="offerData[input.name]"
                          :label="input.label"
                        />
                      </template>
                    </v-col>
                  </template>
                </v-row>
              </fieldset>
            </v-form>

            <v-form
              v-if="!$store.getters.isCentralizedWorkspace"
              class="d-flex flex-column"
              style="gap: 26px;"
            >
              <fieldset
                class="d-flex flex-column py-4 px-4"
                style="gap: 16px; border-radius: 10px; border: 0; background: white;"
              >
                <legend
                  class="
                    py-2 px-4
                    overline text-h6 rounded-lg
                  "
                  style="background-color: #e0e0e0;"
                >
                  Avantages
                </legend>

                <PerksSwitchList
                  v-model="offerData.perks"
                  :read-only="isViewMode"
                  :parent-loading="loading.skeleton"
                />
              </fieldset>
            </v-form>
          </v-card-text>
        </v-col>
        <v-col
          v-if="Object.keys(mandatoryFields).length && !$vuetify.breakpoint.smAndDown"
          cols="2"
          class="pl-4"
        >
          <div
            class="pt-6"
            :style="`position: sticky; top: ${focusModeToolbarTop('mandatoryFields')};`"
          >
            <MandatoryFieldsSection
              :mandatory-fields="mandatoryFields"
              :is-loading="loading.skeleton"
              @scroll-to-field="scrollToField"
            />
          </div>
        </v-col>
      </v-row>
      <v-row
        v-else
        class="relative mx-12 mt-12"
        :style="`top: ${$store.state.focusMode ? '36px': '10px'};`"
      >
        <Preview
          :src="`${appPreviewOffer}${ offerData.uuid}`"
          :content="offerData"
          @iframe-loaded="loading.form = false"
        />
      </v-row>
    </v-card>

    <!-- Mobile: Drawer -->
    <v-navigation-drawer
      v-model="drawer"
      app
      temporary
      right
      style="z-index: 1000;"
    >
      <MandatoryFieldsSection
        :mandatory-fields="mandatoryFields"
        :is-loading="loading.skeleton"
        is-flat
        @scroll-to-field="scrollToField"
      />
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex';

import moment from 'moment';

import { requests } from '@/mixins/index';

import GenericField from '@/components/dynamic/form/templates/GenericField.vue';
import DatePicker from '@/components/dynamic/form/components/DatePicker.vue';
import PositionInput from '@/components/forms/PositionInput.vue';
import ActionsContent from '@/components/dataTable/components/ActionsContent.vue';
import Preview from '@/components/Preview.vue';
import MandatoryFieldsSection from '@/components/dataTable/components/MandatoryFieldsSection.vue';
import EntityInput from '@/components/forms/EntityInput.vue';
import EditToolbar from '@/components/layouts/components/EditToolbar.vue';
import DispatchOffers from '@/components/centralizedOffer/DispatchOffers.vue';
import ConfidentialAccessPopup from '@/components/offer/ConfidentialAccessPopup.vue';
import PerksSwitchList from '@/components/forms/PerksSwitchList.vue';

export default {
  components: { GenericField, DatePicker, PositionInput, ActionsContent, Preview, MandatoryFieldsSection, EntityInput, EditToolbar, DispatchOffers, ConfidentialAccessPopup, PerksSwitchList },
  data () {
    return {
      drawer: false,
      offerData: {},
      defaultData: {},
      job: {},
      positionConventions: [],
      marque: [],
      offerFAQs: [],
      dispatchEntities: [],
      offerPosition: {},
      offerConvention: {},
      isFormOneValid: false,
      isFormTwoValid: false,
      extensionPanel: 0,
      loading: {
        skeleton: true,
        form: true
      },
      showPreview: false,
      appPreviewOffer: `${process.env.VUE_APP_PREVIEW}/preview/recrutement/offer/`,
      offerDetailedContract: null,
      offerEntity: null,
      entityManager: {},
      confidentialDialog: false
    };
  },
  computed: {
    ...mapState(['activeBoardConfiguration', 'user', 'focusMode']),
    ...mapGetters(['canPerformAction', 'hasWorkspaceAccess']),
    isValidForm () {
      return this.isFormOneValid && this.isFormTwoValid;
    },
    hasUuid () {
      return !!this.$route.params.uuid;
    },
    isEditMode () {
      return this.$route.params.mode === 'editer';
    },
    isViewMode () {
      return this.$route.params.mode === 'vue';
    },
    canGenerateOfferLLm () {
      if (!this.$store.getters.isCentralizedWorkspace && this.offerData.status === 'draft') return true;
      return !this.offerData.generatedByModel;
    },
    rawContentType () {
      return {
        ...this.$store.state.rawContentTypes?.Offer,
        fields: {
          ...this.$store.state.rawContentTypes?.Offer?.fields,
          position: this.$store.state.activeBoardConfiguration?.inputs.find(input => input.name === 'position'),
          convention: this.$store.state.activeBoardConfiguration?.inputs.find(input => input.name === 'convention'),
          selectedApplicationMethod: this.$store.state.activeBoardConfiguration?.inputs.find(input => input.name === 'selectedApplicationMethod'),
          startDate: this.$store.state.activeBoardConfiguration?.inputs.find(input => input.name === 'startDate'),
          endDate: this.$store.state.activeBoardConfiguration?.inputs.find(input => input.name === 'endDate'),
          stayOnCenter: this.$store.state.activeBoardConfiguration?.inputs.find(input => input.name === 'stayOnCenter'),
          FTE: this.$store.state.activeBoardConfiguration?.inputs.find(input => input.name === 'FTE')
        }
      } || null;
    },
    computedFields () {
      if (!this.rawContentType?.fields || typeof this.rawContentType.fields !== 'object') return {};

      const fieldsArray = Object.entries(this.rawContentType.fields).map(([key, field]) => {
        const input = this.inputs.find(i => i.name === key);
        const commonProps = { ...input, ...field };

        if (this.isViewMode) {
          return [key, { ...commonProps, readonly: true, disabled: true }];
        }

        return [key, commonProps];
      });

      return Object.fromEntries(fieldsArray);
    },
    inputs () {
      return this.$store.state.activeBoardConfiguration?.inputs || [];
    },
    references () {
      return this.$store.state.references || {};
    },
    workspace () {
      return this.$store.state.activeWorkspace || {};
    },
    mandatoryFields () {
      if (!this.rawContentType?.panelOrder || !this.offerData) return {};

      const mandatoryFieldsByPanel = {};

      [...this.rawContentType.panelOrder, 'Période et contrat de l\'offre'].forEach(panelName => {
        const panelInputs = this.getPanel(panelName);

        const mandatoryInPanel = panelInputs.reduce((accumulator, input) => {
          const field = this.computedFields[input.name];
          const isMandatory = field && (field.mandatory || input.mandatory);
          const isMissing = !this.offerData[input.name];

          if (isMandatory && isMissing) {
            accumulator.push({ ...field, name: input.name });
          }
          return accumulator;
        }, []);

        // If we found any mandatory fields for this panel, add them to our result object.
        if (mandatoryInPanel.length > 0) {
          mandatoryFieldsByPanel[panelName] = mandatoryInPanel;
        }
      });

      return mandatoryFieldsByPanel;
    },
    canPublish () {
      if (this.loading.form) return false;
      if (!this.isValidForm) return false;

      // Centralized workspaces bypass the draft rule
      if (this.$store.getters.isCentralizedWorkspace) return true;

      return this.offerData.status === 'draft';
    },
    hasDifuseLink () {
      return this.offerData.broadBeanUrl;
    },
    canSave () {
      return !this.loading.form && (this.hasChanges && this.offerData.name);
    },
    canReset () {
      return !this.loading.form && this.hasChanges;
    },
    hasChanges () {
      const replacer = (key, value) => (value === '' ? null : value);
      return JSON.stringify(this.offerData, replacer) !== JSON.stringify(this.defaultData, replacer);
    },
    periodStickyPosition () {
      let alertPosition = 0;
      if (this.hasUuid && this.offerData.status === 'published') alertPosition = 68;

      return `${this.$store.state.focusMode ? alertPosition + 90 : alertPosition + 176}px`;
    },
    focusModeToolbarTop () {
      return (section = null) => {
        if (this.$vuetify.breakpoint.xsOnly) {
          return '64px';
        }

        if (section === 'mandatoryFields') {
          return this.focusMode ? '112px' : '150px';
        }

        return this.focusMode ? '24px' : '88px';
      };
    }
  },
  watch: {
    inputs: {
      handler () {
        this.offerData = this.initializeData();
        this.defaultData = { ...this.offerData };
      },
      deep: true,
      immediate: true
    },
    '$route.fullPath': {
      async handler () {
        if (this.hasUuid) {
          await this.getOfferData();
          // this.$store.dispatch('setConfigurationsByWtype', { wtype: 'job' });
        }
      }
    }
  },
  async mounted () {
    // if (this.$store.getters.isCentralizedWorkspace) {
    //   this.$store.dispatch('setConfigurationsByWtype', { wtype: 'model_offer' });
    // }
    if (this.hasUuid) await this.getOfferData();
    else {
      this.$router.push({ name: 'offers' });
    }
  },
  methods: {
    ...mapMutations(['setLoading']),
    async getOfferData () {
      this.setComponentLoading(['skeleton', 'form'], true);

      const response = await requests.getOffer(this.$route.params.uuid);

      if (!response.success || !response.data) {
        this.$store.commit('setSnackbar', { text: 'Contenu introuvable', color: 'error' });
        this.$router.push({ name: 'offers', params: { contentTypeLabel: 'offres' } });

        return;
      }

      const { job, entity, marque, stationCity, tradeUnit, detailedContract, offerFAQs, workspace, applicationMethods, position, convention, perks, ...restData } = response.data;

      this.offerDetailedContract = detailedContract;
      this.offerEntity = entity;

      const accessType = this.isEditMode ? 'WRITE' : 'READ';
      if (!this.hasWorkspaceAccess(workspace, accessType)) {
        this.$router.push({ name: 'error', params: { errorCode: 401 } });
        return;
      }

      this.entityManager.applicationMethods = applicationMethods;

      const lastActiveWorkspace = this.$store.state.activeWorkspace;
      if (this.$store.state.activeWorkspace !== workspace) {
        this.$store.commit('setActiveWorkspace', workspace);
        if (workspace === this.$store.state.centralizedWorkspace || lastActiveWorkspace === this.$store.state.centralizedWorkspace) {
          await this.$store.dispatch('setConfigurationsByWtype', { wtype: 'offer' });
        }
      }

      this.job = job;
      this.offerPosition = position;
      this.offerConvention = convention;

      this.offerData = {
        position: position?.uuid || '',
        convention: convention?.uuid || '',
        job: job?.uuid || '',
        entity: entity?.uuid || '',
        marque: marque?.uuid || '',
        stationCity: stationCity?.uuid || '',
        tradeUnit: tradeUnit?.uuid || '',
        detailedContract: detailedContract?.uuid || '',
        offerFAQs: offerFAQs?.uuid || '',
        perks: perks?.map(p => p.uuid) || [],
        ...restData
      };

      this.defaultData = { ...this.offerData };

      this.setComponentLoading(['skeleton', 'form'], false);
    },
    async saveOffer (status = 'draft') {
      this.setComponentLoading('form', true);

      const { configs } = this.rawContentType;

      const currentDate = moment().utc();

      if (this.offerData.startPublicationDate && moment(this.offerData.startPublicationDate).isSame(currentDate, 'day')) {
        this.offerData.startPublicationDate = currentDate.format('YYYY-MM-DDTHH:mm:ssZ');
      }

      if (this.offerData.detailedContractHoursString) {
        this.offerData.detailedContractHoursString = this.offerData.detailedContractHoursString.replace(',', '.').replace(/[^0-9.]/g, '');
      }

      // Remove properties that are not defined by the type
      const { contractHoursLabel, dispatchedOffers, ...restOfferData } = this.offerData;

      const response = await requests.saveOffer({
        input: {
          ...restOfferData,
          workspace: this.workspace,
          status
        },
        isEditMode: true,
        mutationName: configs.update
      });

      if (!response.success) {
        // SHOW ERROR MESSAGE
        console.error(response.message);
        this.$store.commit('setSnackbar', { text: 'Une erreur est survenue lors de l\'enregistrement de l\'offre', color: 'error' });
        this.setComponentLoading('form', false);

        return;
      }

      this.offerData.version = response.data.version;
      this.offerData.uuid = response.data.uuid;
      this.offerData.status = response.data.status;
      this.defaultData = { ...this.offerData };

      this.$store.commit('setSnackbar', { text: status === 'draft' ? 'Enregistrer avec succès.' : 'Publié avec succès.', color: 'success' });

      this.setComponentLoading('form', false);
    },
    async handleBroadBeanApplication () {
      if (!this.user.broadBeanUsername) return;

      this.setComponentLoading('form', true);

      try {
        const newUrl = await requests.getBroadBeanNewUrl(this.offerData.broadBeanUuid, this.offerData.uuid, this.user.broadBeanUsername);

        if (!newUrl) {
          this.$store.commit('setSnackbar', { text: 'Impossible de récupérer le lien de diffusion', color: 'error' });
          return;
        }

        window.open(newUrl, '_blank');
      } catch (error) {
        console.error('Error fetching BroadBean status or URL:', error);
      } finally {
        this.setComponentLoading('form', false);
      }
    },
    async openFile () {
      if (!this.offerData.uuid) return;

      try {
        // Get the file data (assuming it returns base64)
        const { data } = await requests.generateOfferPDF({
          name: this.offerData.name,
          url: `${this.$store.state.appUrl}/offres-d-emploi${this.offerData.url}`,
          entityName: this.offerEntity.name,
          contract: this.offerData.contract,
          detailedContract: this.offerDetailedContract?.name,
          contractHours: this.offerData.contractHoursLabel,
          detailedContractHoursString: this.offerData.detailedContractHoursString,
          salary: this.offerData.salary,
          AIDescription: this.offerData.AIDescription,
          AIMissions: this.offerData.AIMissions,
          AIProfile: this.offerData.AIProfile
        });

        // Check if data is not a base64 string
        if (typeof data !== 'string') {
          console.info('Format de données non valide');
          return;
        }

        // Create a base64 data URL if needed
        let dataUrl = data;
        if (!data.startsWith('data:')) {
          // Try to determine the file type or default to generic binary
          const isPdf = data.substring(0, 20).includes('JVBERi0'); // Basic check for PDF header in base64
          const mimeType = isPdf ? 'application/pdf' : 'application/octet-stream';
          dataUrl = `data:${mimeType};base64,${data}`;
        }

        // Create download link
        const anchor = document.createElement('a');
        anchor.href = dataUrl;
        const fileName = (this.offerData.name || 'fichier_poste').replace(/\s+/g, '_');
        anchor.download = `${fileName}.pdf`; // Add .pdf extension explicitly

        // Trigger download
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);
      } catch (error) {
        console.error('Error downloading file:', error);
      }
    },
    async duplicateOffer (saveCurrentOffer) {
      this.$store.commit('resetDialog');

      if (saveCurrentOffer) {
        await this.saveOffer(this.offerData.status);
      }

      this.setComponentLoading('form', true);
      const response = await requests.duplicateOffer({ uuid: this.offerData.uuid, workspace: this.workspace });

      if (!response.success) {
        this.$store.commit('setSnackbar', { text: 'Erreur lors de la duplication de l\'offre', color: 'error' });
        return;
      }

      this.offerData.uuid = response.data;

      this.$store.commit('setSnackbar', { text: 'Offre dupliquée avec succès', color: 'success' });
      this.$router.push({ name: 'offer', params: { contentTypeLabel: 'offres', mode: 'vue', uuid: this.offerData.uuid } });
      this.setComponentLoading('form', false);
    },
    async generateOfferLLmData () {
      this.$store.commit('resetDialog');

      if (this.hasChanges) {
        await this.saveOffer(this.offerData.status);
      }

      this.setComponentLoading('form', true);

      this.$store.commit('setSnackbar', { text: 'Génération des données du llm en cours...', color: 'info', timeout: -1 });
      const response = await requests.generateOfferLLmData({ uuid: this.offerData.uuid });

      if (!response.success && response.message !== 'GATEWAY_TIMEOUT') {
        this.$store.commit('setSnackbar', { text: 'Erreur lors de la récupération des données du llm', color: 'error' });
        this.setComponentLoading('form', false);
        return;
      }

      this.setComponentLoading('form', false);
      this.$store.commit('setSnackbar', { text: 'Données du llm récupérées avec succès', color: 'success' });

      this.$router.go();
    },
    async dispatchOffer (status = 'draft') {
      if (this.hasChanges) {
        await this.saveOffer(status);
      }

      const entities = this.dispatchEntities.map(entity => ({ uuid: entity.uuid, workspaceID: entity.workspaceSettings.workspaceID }));
      const response = await requests.dispatchOffer({ uuid: this.$route.params.uuid, entities, status });

      if (!response.success) {
        this.$store.commit('setSnackbar', { text: 'Erreur lors de la publication de l\'offre', color: 'error' });
        return;
      }

      this.offerData.dispatchedOffers = [
        ...(this.offerData.dispatchedOffers || []),
        ...this.dispatchEntities.map((entity, entityIndex) => {
          const newUuids = response.data.dispatchedOfferUuids.slice(-this.dispatchEntities.length);
          return { entity, uuid: newUuids[entityIndex] };
        })
      ];
      this.dispatchEntities = [];

      this.$store.commit('setSnackbar', { text: `${status === 'published' ? 'Publiée et dispatchée avec succès' : 'Dispatchée avec succès'}`, color: 'success' });
    },
    resetModifications () {
      this.getOfferData();
    },
    initializeData () {
      return this.inputs.reduce((acc, input) => {
        acc[input.name] = input.defaultValue || null;
        return acc;
      }, {});
    },
    openDialogByType (type = 'offer', data = { status: 'draft' }) {
      switch (type) {
        case 'offer':
          this.$store.commit('setDialog', { show: true, title: 'Confirmation', text: 'Souhaitez-vous confirmer la publication de l\'offre ?', handleAccept: () => this.saveOffer(data.status) });
          break;
        case 'duplicateOffer': {
          const saveCurrentOffer = false;

          const dialog = {
            show: true,
            title: 'Dupliquer l\'offre',
            text: `Souhaitez-vous confirmer la duplication de l'offre: ${this.offerData.name} ?`,
            handleAccept: (checked = saveCurrentOffer) => this.duplicateOffer(checked)
          };

          if (this.hasChanges) {
            dialog.checkbox = {
              show: true,
              checked: saveCurrentOffer,
              label: 'Appliquer les modifications à l\'offre actuelle et à sa duplication'
            };
          }

          this.$store.commit('setDialog', dialog);
          break;
        }
        case 'generateOfferLLmData':
          this.$store.commit('setDialog', { show: true, title: 'Générer llm', text: 'Souhaitez-vous confirmer la génération du llm ?', handleAccept: this.generateOfferLLmData });
          break;
        default:
          console.info('Type not found:', type);
          break;
      }
    },
    setEntityItems (entityName, items) {
      this.entityManager[entityName] = items;
    },
    initEntity (entityName, entity) {
      this.offerData[entityName] = entity.uuid;
      if (!this.offerData.selectedApplicationMethod || !this.offerData.applicationDescription || !this.offerData.applicationProcedure) {
        this.setApplicationMethod(entity);
      }
    },
    setSelectedEntity (entityName, entity) {
      this.offerData[entityName] = entity.uuid;
      this.setApplicationMethod(entity);
    },
    setApplicationMethod (item) {
      this.offerData.selectedApplicationMethod = item ? item.uuid : null;
      this.offerData.applicationDescription = item ? item.description || '' : null;
      this.offerData.applicationProcedure = item ? item.procedure || '' : null;
    },
    getInputClasses (field) {
      const classes = [field.mandatory ? 'required' : ''];

      if (this.isViewMode) classes.push('input-color-black');

      return classes.join(' ');
    },
    showField (inputName) {
      switch (inputName) {
        case 'position': {
          return true;
        }
        case 'convention': {
          if (this.positionConventions && Object.keys(this.positionConventions).length) {
            return true;
          }
          return false;
        }
        case 'endDate': {
          if (this.offerData.contract && ['CDD', 'STAGIAIRE', 'CONTRAT_DAPPRENTISSAGE'].includes(this.offerData.contract)) {
            return true;
          }

          this.offerData.endDate = null;
          return false;
        }
        default:
          break;
      }

      return (this.computedFields[inputName]);
    },
    handleCol (input) {
      switch (input.name) {
        case 'startDate': {
          if (this.offerData.contract && ['CDD', 'STAGIAIRE', 'CONTRAT_DAPPRENTISSAGE'].includes(this.offerData.contract)) {
            return 6;
          }
          return 12;
        }
        case 'endDate': {
          if (this.offerData.contract && ['CDD', 'STAGIAIRE', 'CONTRAT_DAPPRENTISSAGE'].includes(this.offerData.contract)) {
            return 6;
          }

          break;
        }
        default:
          break;
      }

      return input.col || 12;
    },
    getPanel (panel) {
      return this.inputs.filter(input => {
        const computedField = this.computedFields[input.name];
        const panelValue = input?.panel || computedField?.panel;
        return panelValue.includes(panel) ? input : null;
      });
    },
    getFieldItems (field) {
      if (field.optionsByReference && Object.keys(this.references[field.optionsByReference]).length) {
        if (field.name === 'startDateInfo') {
          const startDateInfoOptionsByContract = {
            CDD: ['ASAP', 'FROM_TO'],
            STAGIAIRE: ['ASAP', 'FROM_TO'],
            CONTRAT_DAPPRENTISSAGE: ['ASAP', 'FROM_TO'],
            CDI: ['ASAP', 'FROM'],
            CIVIQUE: ['ASAP', 'FROM']
          };

          if (!this.offerData.contract) {
            return [];
          }

          const allowedKeys = startDateInfoOptionsByContract[this.offerData.contract];
          if (!allowedKeys) {
            return [];
          }

          const allOptions = this.references[field.optionsByReference];

          return Object.entries(allOptions)
            .filter(([key]) => allowedKeys.includes(key))
            .map(([key, value]) => ({ text: value, value: key }));
        }

        return Object.entries(this.references[field.optionsByReference]).map(([key, value]) => ({ text: value, value: key }));
      }

      if (field.name === 'selectedApplicationMethod' && this.entityManager.applicationMethods?.length) {
        return this.entityManager.applicationMethods.map(item => ({ text: item.name, value: item.uuid }));
      }

      return [];
    },
    getInputConventions (convention) {
      return [].concat(convention).reduce((acc, item) => {
        if (!item) return acc;

        acc.push({
          value: item.uuid,
          text: item.name
        });
        return acc;
      }, []);
    },
    handlePosition (position, resetConvention = false) {
      // Case 1: The position is cleared.
      if (!position) {
        this.offerData.name = null;
        this.offerData.experience = null;
        this.offerData.convention = null;
        this.positionConventions = [];

        return;
      }

      // Case 2: A new position is selected.
      const { wtitle, experience, convention } = position;

      // Update the job data.
      this.offerData.name = wtitle;
      this.offerData.experience = experience;
      if (resetConvention) this.offerData.convention = null; // Reset convention selection.

      // Update the available conventions for the dropdown.
      this.positionConventions = this.getInputConventions(convention);
    },
    handlePositionInit (position) {
      if (!position) return;

      const { wtitle, experience, convention } = position;

      // Only set name if it doesn't already have a value (preserve existing data on load)
      if (!this.offerData.name) {
        this.offerData.name = wtitle;
      }

      // Only set experience if it doesn't already have a value
      if (!this.offerData.experience) {
        this.offerData.experience = experience;
      }

      // Update the available conventions for the dropdown.
      this.positionConventions = this.getInputConventions(convention);
    },
    handleItem (item, fieldName) {
      if (fieldName === 'position') {
        this.handlePosition(item, true);
      }
    },
    handleConfidentialChange () {
      this.offerData.confidential = !this.offerData.confidential;
      if (this.offerData.confidential) {
        this.offerData.allowedCollaborators = [{
          email: this.user.email,
          fullName: `${this.user.firstname} ${this.user.lastname}`
        }];
        this.confidentialDialog = true;
      } else {
        this.offerData.allowedCollaborators = [];
      }
    },
    setShowPreview () {
      this.showPreview = !this.showPreview;
      this.loading.form = this.showPreview;
    },
    setComponentLoading (keys, value) {
      [].concat(keys).forEach(key => {
        this.loading[key] = value;
      });
    },
    scrollToField (field) {
      const element = this.$refs[field];

      if (!element) { return; }

      const targetElement = Array.isArray(element) ? element[0] : element;

      this.$vuetify.goTo(targetElement, {
        duration: 500,
        offset: 64 + 16,
        easing: 'easeInOutCubic'
      });

      targetElement.querySelector('input, textarea, select')?.focus();
    },
    goBack () {
      this.$router.go(-1);
    },
    getRules (inputName) {
      switch (inputName) {
        case 'detailedContractHoursString': {
          return [
            v => {
              if (!v) return true;
              return /^-?\d+(\.\d{0,1})?$/.test(v.replace(',', '.')) || 'Le nombre d\'heures doit être un nombre avec au plus un décimal';
            }
          ];
        }
        default:
          break;
      }
      return [];
    }
  }
};
</script>

<style scoped>
  .v-list-item__subtitle {
    white-space: break-spaces;
  }

  @container edit-toolbar (max-width: 1200px) {
    :deep(.desktop-actions) {
      display: none;
    }

    :deep(.mobile-actions) {
      display: block;
    }
  }
</style>
